<template>
	<b-card no-body>
		<b-row class="d-flex align-items-start">
			<!-- LEFT SECTION -->
			<b-col cols="auto" class="p-3">
				<div class="d-flex align-items-center">
					<div class="p-0 mx-2">
						<el-input placeholder="Search by text" v-model="filters.search_txt" @change="getListing()"> <i slot="prefix"
								class="el-input__icon el-icon-search"></i>
						</el-input>
					</div>
				</div>
			</b-col>

			<!-- RIGHT SECTION -->
			<b-col cols="auto" class="ml-auto p-3 mx-2">
				<b-row class="d-flex align-items-center">
					<b-col cols="auto">
						<b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
					</b-col>
				</b-row>
			</b-col>
		</b-row>

		<!-- TABLE LIST -->
		<div class="table-listings">
			<el-table ref="multipleTable" v-loading="isTableLoading" :data="queriedData" style="width: 100%;">
				<el-table-column prop="notif_temp_type" label="Type" sortable>
					<template slot-scope="scope">
						<p class="text-capitalize">{{ scope.row.notif_temp_type }}</p>
					</template>
				</el-table-column>

				<el-table-column prop="notif_temp_title" label="Title" sortable>
					<template slot-scope="scope">
						<p class="text-capitalize">{{ scope.row.notif_temp_title }}</p>
					</template>
				</el-table-column>

				<el-table-column prop="notif_temp_message" label="Content" sortable min-width="200">
					<template slot-scope="scope">
						<p class="font-weight-bold text-primary">{{ scope.row.notif_temp_message }}</p>
					</template>
				</el-table-column>

				<!-- Trigger Point Column -->
				<el-table-column prop="trigger_point" label="Trigger Point" sortable>
					<template slot-scope="scope">
						<p class="text-capitalize">{{ _gHlp.getValue(_gConst.emailTriggerPoints,scope.row.trigger_point) }}</p>
					</template>
				</el-table-column>

				<!-- STATUS CREATED AT COLUMN -->
				<el-table-column prop="created_at" label="Date Created" sortable>
					<template slot-scope="scope">
						<div v-if="scope.row.created_at">
							{{ scope.row.created_at | dateFormatString }}
						</div>
					</template>

				</el-table-column>

				<!-- STATUS ACTIONS COLUMN -->
				<el-table-column width="55" fixed="right">
					<template slot-scope="scope">
						<el-dropdown :tabindex="scope.row.id" class="py-2">
							<b class="el-dropdown-link">
								<b-icon icon="three-dots-vertical">
								</b-icon>
							</b>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="openModal(scope.row)">
									Edit
								</el-dropdown-item>
								<el-dropdown-item @click.native="deleteItem(scope.row.notif_temp_id)">
									Delete
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</template>

				</el-table-column>

			</el-table>
		</div>

		<!-- FOOTER -->
		<!-- FOOTER -->
		<div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
			<div class="">
				<p class="card-category">
					Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
					<span v-if="selectedRows.length">
						&nbsp; &nbsp; {{ selectedRows.length }} rows selected
					</span>
				</p>
			</div>
			<base-pagination class="pagination-no-border" :current="pagination.currentPage" :per-page="pagination.perPage"
				:total="pagination.total" @change="paginationChanged($event)">
			</base-pagination>
		</div>

		<EmailForm ref="modal_email_form"  @closeModal="closeModal"  />
	</b-card>
</template>
<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import EmailForm from '@/views/AllSettings/TemplatePages/EmailTemplates/EmailForm'
import { cloneDeep } from 'lodash'
import { swal } from '@/assets/js/httpImports.js'
import { mapState, mapActions } from 'pinia'
import { useNotificationStore } from '@/stores/notificationStore'

export default {
	mixins: [clientPaginationMixin],
	components: {
		EmailForm,
		BasePagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[Select.name]: Select,
		[Option.name]: Option,
		[Button.name]: Button,
		[Dropdown.name]: Dropdown,
		[DropdownMenu.name]: DropdownMenu,
		[DropdownItem.name]: DropdownItem,
	},
	data() {
		return {
			isTableLoading: true,
			propsToSearch: ['sms_title', 'sms_content'],
			currentPage: 1,
			mode: 'listing',
			selectedRows: [],
			TableColumn: [{
				type: 'selection'
			}],
			tableData: [],
			pagination: {
				perPageOptions: [5, 10, 25, 50, 100, 500]
			},
			filters:{
				search_txt:''
			}
		}
	},
	created() {
		this.initComponent()
	},
	mounted() {},
	beforeUnmount() {},
	methods: {
		...mapActions(useNotificationStore, ['getTemplates','deleteTemplate']),
		initComponent(){
			this.getListing();
		},
		filterTableData() {
			// Apply filter based on search query
			this.queriedData = this.tableData.filter(item => {
				const typeMatch = item.notif_temp_type ? item.notif_temp_type.toLowerCase().includes(this.searchQuery.toLowerCase()) : false;
				const titleMatch = item.notif_temp_title ? item.notif_temp_title.toLowerCase().includes(this.searchQuery.toLowerCase()) : false;
				const messageMatch = item.notif_temp_message ? item.notif_temp_message.toLowerCase().includes(this.searchQuery.toLowerCase()) : false;
				return typeMatch || titleMatch || messageMatch;
			});

		},
		selectionChange(selectedRows) {
			this.selectedRows = selectedRows
		},
		paginationChanged(page) {
			this.pagination.currentPage = page
			this.getListing()
		},
		getListing() {
			this.isTableLoading = true
			const params = {
				search:{
					notif_temp_type: 'email'
				}
			}
			this.getTemplates(params).then((resp) => {
				console.log(resp);
				this.tableData = resp.filter(item => {
					return item.notif_temp_type == 'email'
				});
				this.isTableLoading = false
			}).catch((err)=>{
				this.isTableLoading = false
			})
		},
		deleteItem(id) {
			swal.fire({
				title: 'Are you sure?',
				text: "You won't be able to revert this!",
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Yes, delete it!'
			}).then((result) => {
				if (result.isConfirmed) {
					this.isTableLoading = true
					this.deleteTemplate(id).then((resp) => {
						this.getListing()
						_gNotif.notifySuccess('<b>Status: </b> - Successfully Deleted.')
						this.isTableLoading = false
					}).catch((err)=>{
						this.isTableLoading = false
					})
				}
			})
		},
		openModal(item = null) {
			this.$refs.modal_email_form.show(cloneDeep(item))
		},
		closeModal(refresh=false) {
			if(refresh){
				this.getListing()
			}
		},
	}
}
</script>